module.exports = __webpack_public_path__ + "img/one.386c7865.jpg";